import { render, staticRenderFns } from "./WorkOrderFeedBack.vue?vue&type=template&id=d632280e"
import script from "../../scripts/pages/WorkOrderFeedback.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/WorkOrderFeedback.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports